<template>
	<sa-page-layout :btnBackVisible="true" :linkback="linkback" :linkedit="linkedit" :pathResource="pathResource" :showModalLoading="showModalLoading">
		<!--  <template slot="toolbar-actions">
        </template> -->
		<template slot="toolbar-title">
			<rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
		</template>
		<template slot="table-body">
			<rsa-scheda-ospite-uscite-list-component ref="cmpRsaOspiteUsciteListComponent" :jsonDataAccettazione="jsonData" :utente="utente" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
		</template>
	</sa-page-layout>
</template>

<script>
import axios from "axios";
/* import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue"; */
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaSchedaOspiteUsciteListComponent from "../../rsagestioneospiti/components/RsaSchedaOspiteUsciteListComponent.vue";
export default {
	name: "RsaPazienteUscitePage",
	props: {
		utente: { type: Object },
	},
	components: {
		SaPageLayout,
		RsaOspiteAnagraficaComponent,
		RsaSchedaOspiteUsciteListComponent,
	},
	data() {
		return {
			idAccettazione: null,
			btnNuovaRichiestaEsameHidden: true,
			btnNuovaRichiestaUscita: true,
			filtro: {},
			btnNewVisible: true,
			pathResource: null,
			pathResourceAccettazione: "/accettazioni",
			linkedit: null,
			linkback: "/rsagestioneospiti",
			showModalLoading: false,
			listKey: 0,
			jsonData: { accettazioneAnagrafica: {}, accettazionePrestazioni: {}, accettazioneStati: [], accettazioneStruttura: {}, accettazionePresidio: {} },
		};
	},
	mounted() {
		let me = this;
		me.idAccettazione = this.$route.query.idAccettazione;
		me.loadAccettazione();
	},
	methods: {
		loadAccettazione() {
			let me = this;
			me.showModalLoading = true;
			let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
			axios.get(link)
				.then((response) => {
					me.jsonData = response.data.data;
					me.$refs.cmpRsaOspiteUsciteListComponent.init(me.jsonData);
					me.showModalLoading = false;
				})
				.catch(() => {
					me.showModalLoading = false;
				});
		},
		onAfterLoadData() {
			let me = this;
			me.showModalLoading = false;
		},
		onBeforeLoadData() {
			let me = this;
			me.showModalLoading = true;
		},
		onClickAggiorna() {
			let me = this;
			me.$refs.cmpRsaOspiteUsciteListComponent.onClickAggiorna();
		},
	},
};
</script>

<style></style>
